package com.xtream.data_kmp.db.dao

import androidx.paging.PagingSource
import androidx.room3.EntityDeleteOrUpdateAdapter
import androidx.room3.EntityInsertAdapter
import androidx.room3.RoomDatabase
import androidx.room3.RoomRawQuery
import androidx.room3.coroutines.createFlow
import androidx.room3.paging.PagingSourceDaoReturnTypeConverter
import androidx.room3.util.getColumnIndexOrThrow
import androidx.room3.util.performSuspending
import androidx.sqlite.SQLiteStatement
import com.xtream.data_kmp.db.tables.VodCategoryWithVisibleStatus
import com.xtream.data_kmp.dto.VodCategory
import com.xtream.data_kmp.dto.VodCategoryWithSize
import kotlin.Boolean
import kotlin.Int
import kotlin.Long
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlin.collections.MutableList
import kotlin.collections.mutableListOf
import kotlin.reflect.KClass
import kotlinx.coroutines.flow.Flow

@Suppress(names = ["UNCHECKED_CAST", "DEPRECATION", "REDUNDANT_PROJECTION", "REMOVAL", "MemberExtensionConflict"])
internal class VodCategoriesDao_Impl(
  __db: RoomDatabase,
) : VodCategoriesDao() {
  private val __db: RoomDatabase

  private val __insertAdapterOfVodCategory: EntityInsertAdapter<VodCategory>

  private val __deleteAdapterOfVodCategory: EntityDeleteOrUpdateAdapter<VodCategory>

  private val __pagingSourceDaoReturnTypeConverter: PagingSourceDaoReturnTypeConverter =
      PagingSourceDaoReturnTypeConverter()
  init {
    this.__db = __db
    this.__insertAdapterOfVodCategory = object : EntityInsertAdapter<VodCategory>() {
      protected override fun createQuery(): String = "INSERT OR REPLACE INTO `vodCategoriesTable` (`categoryId`,`categoryName`,`parentId`,`created_at`) VALUES (?,?,?,?)"

      protected override fun bind(statement: SQLiteStatement, entity: VodCategory) {
        statement.bindLong(1, entity.categoryId.toLong())
        val _tmpCategoryName: String? = entity.categoryName
        if (_tmpCategoryName == null) {
          statement.bindNull(2)
        } else {
          statement.bindText(2, _tmpCategoryName)
        }
        val _tmpParentId: Int? = entity.parentId
        if (_tmpParentId == null) {
          statement.bindNull(3)
        } else {
          statement.bindLong(3, _tmpParentId.toLong())
        }
        statement.bindLong(4, entity.createdAt)
      }
    }
    this.__deleteAdapterOfVodCategory = object : EntityDeleteOrUpdateAdapter<VodCategory>() {
      protected override fun createQuery(): String = "DELETE FROM `vodCategoriesTable` WHERE `categoryId` = ?"

      protected override fun bind(statement: SQLiteStatement, entity: VodCategory) {
        statement.bindLong(1, entity.categoryId.toLong())
      }
    }
  }

  public override suspend fun insert(item: VodCategory): Unit = performSuspending(__db, false, true) { _connection ->
    __insertAdapterOfVodCategory.insert(_connection, item)
  }

  public override suspend fun insert(items: List<VodCategory>): Unit = performSuspending(__db, false, true) { _connection ->
    __insertAdapterOfVodCategory.insert(_connection, items)
  }

  public override suspend fun delete(item: VodCategory): Unit = performSuspending(__db, false, true) { _connection ->
    __deleteAdapterOfVodCategory.handle(_connection, item)
  }

  public override suspend fun delete(items: List<VodCategory>): Unit = performSuspending(__db, false, true) { _connection ->
    __deleteAdapterOfVodCategory.handleMultiple(_connection, items)
  }

  public override fun allAsFlow(): Flow<List<VodCategory>> {
    val _sql: String = "SELECT * FROM vodCategoriesTable ORDER BY created_at"
    return createFlow(__db, false, arrayOf("vodCategoriesTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfCategoryName: Int = getColumnIndexOrThrow(_stmt, "categoryName")
        val _columnIndexOfParentId: Int = getColumnIndexOrThrow(_stmt, "parentId")
        val _columnIndexOfCreatedAt: Int = getColumnIndexOrThrow(_stmt, "created_at")
        val _result: MutableList<VodCategory> = mutableListOf()
        while (_stmt.step()) {
          val _item: VodCategory
          val _tmpCategoryId: Int
          _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          val _tmpCategoryName: String?
          if (_stmt.isNull(_columnIndexOfCategoryName)) {
            _tmpCategoryName = null
          } else {
            _tmpCategoryName = _stmt.getText(_columnIndexOfCategoryName)
          }
          val _tmpParentId: Int?
          if (_stmt.isNull(_columnIndexOfParentId)) {
            _tmpParentId = null
          } else {
            _tmpParentId = _stmt.getLong(_columnIndexOfParentId).toInt()
          }
          val _tmpCreatedAt: Long
          _tmpCreatedAt = _stmt.getLong(_columnIndexOfCreatedAt)
          _item = VodCategory(_tmpCategoryId,_tmpCategoryName,_tmpParentId,_tmpCreatedAt)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun allAsPagingSource(): PagingSource<Int, VodCategory> {
    val _sql: String = "SELECT * FROM vodCategoriesTable ORDER BY created_at"
    val _rawQuery: RoomRawQuery = RoomRawQuery(_sql)
    return __pagingSourceDaoReturnTypeConverter.convert(__db, arrayOf("vodCategoriesTable"), _rawQuery) { _converterQuery ->
      performSuspending<MutableList<VodCategory>>(__db, true, false) { _connection ->
        val _stmt: SQLiteStatement = _connection.prepare(_converterQuery.sql)
        try {
          _converterQuery.getBindingFunction().invoke(_stmt)
          val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
          val _columnIndexOfCategoryName: Int = getColumnIndexOrThrow(_stmt, "categoryName")
          val _columnIndexOfParentId: Int = getColumnIndexOrThrow(_stmt, "parentId")
          val _columnIndexOfCreatedAt: Int = getColumnIndexOrThrow(_stmt, "created_at")
          val _result: MutableList<VodCategory> = mutableListOf()
          while (_stmt.step()) {
            val _item: VodCategory
            val _tmpCategoryId: Int
            _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
            val _tmpCategoryName: String?
            if (_stmt.isNull(_columnIndexOfCategoryName)) {
              _tmpCategoryName = null
            } else {
              _tmpCategoryName = _stmt.getText(_columnIndexOfCategoryName)
            }
            val _tmpParentId: Int?
            if (_stmt.isNull(_columnIndexOfParentId)) {
              _tmpParentId = null
            } else {
              _tmpParentId = _stmt.getLong(_columnIndexOfParentId).toInt()
            }
            val _tmpCreatedAt: Long
            _tmpCreatedAt = _stmt.getLong(_columnIndexOfCreatedAt)
            _item = VodCategory(_tmpCategoryId,_tmpCategoryName,_tmpParentId,_tmpCreatedAt)
            _result.add(_item)
          }
          _result
        } finally {
          _stmt.close()
        }
      }
    }
  }

  public override suspend fun hasEntity(id: Int): Boolean {
    val _sql: String = "SELECT EXISTS (SELECT 1 FROM vodCategoriesTable WHERE categoryId = ?)"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindLong(_argIndex, id.toLong())
        val _result: Boolean
        if (_stmt.step()) {
          val _tmp: Int
          _tmp = _stmt.getLong(0).toInt()
          _result = _tmp != 0
        } else {
          _result = false
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun hasEntityAsFlow(id: Int?): Flow<Boolean> {
    val _sql: String = "SELECT EXISTS (SELECT 1 FROM vodCategoriesTable WHERE categoryId = ?)"
    return createFlow(__db, false, arrayOf("vodCategoriesTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        if (id == null) {
          _stmt.bindNull(_argIndex)
        } else {
          _stmt.bindLong(_argIndex, id.toLong())
        }
        val _result: Boolean
        if (_stmt.step()) {
          val _tmp: Int
          _tmp = _stmt.getLong(0).toInt()
          _result = _tmp != 0
        } else {
          _result = false
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun getSize(): Long? {
    val _sql: String = "SELECT COUNT(*) FROM vodCategoriesTable"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _result: Long?
        if (_stmt.step()) {
          val _tmp: Long?
          if (_stmt.isNull(0)) {
            _tmp = null
          } else {
            _tmp = _stmt.getLong(0)
          }
          _result = _tmp
        } else {
          _result = null
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun getPagedCategories(): PagingSource<Int, VodCategory> {
    val _sql: String = "SELECT * FROM vodCategoriesTable"
    val _rawQuery: RoomRawQuery = RoomRawQuery(_sql)
    return __pagingSourceDaoReturnTypeConverter.convert(__db, arrayOf("vodCategoriesTable"), _rawQuery) { _converterQuery ->
      performSuspending<MutableList<VodCategory>>(__db, true, false) { _connection ->
        val _stmt: SQLiteStatement = _connection.prepare(_converterQuery.sql)
        try {
          _converterQuery.getBindingFunction().invoke(_stmt)
          val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
          val _columnIndexOfCategoryName: Int = getColumnIndexOrThrow(_stmt, "categoryName")
          val _columnIndexOfParentId: Int = getColumnIndexOrThrow(_stmt, "parentId")
          val _columnIndexOfCreatedAt: Int = getColumnIndexOrThrow(_stmt, "created_at")
          val _result: MutableList<VodCategory> = mutableListOf()
          while (_stmt.step()) {
            val _item: VodCategory
            val _tmpCategoryId: Int
            _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
            val _tmpCategoryName: String?
            if (_stmt.isNull(_columnIndexOfCategoryName)) {
              _tmpCategoryName = null
            } else {
              _tmpCategoryName = _stmt.getText(_columnIndexOfCategoryName)
            }
            val _tmpParentId: Int?
            if (_stmt.isNull(_columnIndexOfParentId)) {
              _tmpParentId = null
            } else {
              _tmpParentId = _stmt.getLong(_columnIndexOfParentId).toInt()
            }
            val _tmpCreatedAt: Long
            _tmpCreatedAt = _stmt.getLong(_columnIndexOfCreatedAt)
            _item = VodCategory(_tmpCategoryId,_tmpCategoryName,_tmpParentId,_tmpCreatedAt)
            _result.add(_item)
          }
          _result
        } finally {
          _stmt.close()
        }
      }
    }
  }

  public override fun getPagingCategoriesWithSize(): PagingSource<Int, VodCategoryWithSize> {
    val _sql: String = """
        |
        |    SELECT 
        |    category.*, 
        |    CASE 
        |        WHEN category.categoryId = -2 THEN (SELECT COUNT(streamId) FROM vodFavoritesTable)
        |        WHEN category.categoryId = -3 THEN (SELECT COUNT(streamId) FROM watchedVodStreamsTable)
        |        ELSE (SELECT COUNT(streamId) FROM vodTable WHERE categoryId = category.categoryId)
        |    END AS size  
        |FROM vodCategoriesTable AS category
        |GROUP BY category.categoryId
        |ORDER BY category.created_at
        |""".trimMargin()
    val _rawQuery: RoomRawQuery = RoomRawQuery(_sql)
    return __pagingSourceDaoReturnTypeConverter.convert(__db, arrayOf("vodFavoritesTable", "watchedVodStreamsTable", "vodTable", "vodCategoriesTable"), _rawQuery) { _converterQuery ->
      performSuspending<MutableList<VodCategoryWithSize>>(__db, true, false) { _connection ->
        val _stmt: SQLiteStatement = _connection.prepare(_converterQuery.sql)
        try {
          _converterQuery.getBindingFunction().invoke(_stmt)
          val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
          val _columnIndexOfCategoryName: Int = getColumnIndexOrThrow(_stmt, "categoryName")
          val _columnIndexOfParentId: Int = getColumnIndexOrThrow(_stmt, "parentId")
          val _columnIndexOfCreatedAt: Int = getColumnIndexOrThrow(_stmt, "created_at")
          val _columnIndexOfSize: Int = getColumnIndexOrThrow(_stmt, "size")
          val _result: MutableList<VodCategoryWithSize> = mutableListOf()
          while (_stmt.step()) {
            val _item: VodCategoryWithSize
            val _tmpSize: Int
            _tmpSize = _stmt.getLong(_columnIndexOfSize).toInt()
            val _tmpCategory: VodCategory
            val _tmpCategoryId: Int
            _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
            val _tmpCategoryName: String?
            if (_stmt.isNull(_columnIndexOfCategoryName)) {
              _tmpCategoryName = null
            } else {
              _tmpCategoryName = _stmt.getText(_columnIndexOfCategoryName)
            }
            val _tmpParentId: Int?
            if (_stmt.isNull(_columnIndexOfParentId)) {
              _tmpParentId = null
            } else {
              _tmpParentId = _stmt.getLong(_columnIndexOfParentId).toInt()
            }
            val _tmpCreatedAt: Long
            _tmpCreatedAt = _stmt.getLong(_columnIndexOfCreatedAt)
            _tmpCategory = VodCategory(_tmpCategoryId,_tmpCategoryName,_tmpParentId,_tmpCreatedAt)
            _item = VodCategoryWithSize(_tmpCategory,_tmpSize)
            _result.add(_item)
          }
          _result
        } finally {
          _stmt.close()
        }
      }
    }
  }

  public override fun getCategoriesWithVisibleStatus(): Flow<List<VodCategoryWithVisibleStatus>> {
    val _sql: String = """
        |
        |    SELECT c.*,
        |           CASE WHEN h.categoryId IS NULL THEN 0 ELSE 1 END AS isHidden
        |    FROM vodCategoriesTable c
        |    LEFT JOIN hidden_categories h
        |        ON c.categoryId = h.categoryId
        |       AND h.type = 'MOVIE'
        |""".trimMargin()
    return createFlow(__db, false, arrayOf("vodCategoriesTable", "hidden_categories")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _columnIndexOfCategoryId: Int = getColumnIndexOrThrow(_stmt, "categoryId")
        val _columnIndexOfCategoryName: Int = getColumnIndexOrThrow(_stmt, "categoryName")
        val _columnIndexOfParentId: Int = getColumnIndexOrThrow(_stmt, "parentId")
        val _columnIndexOfCreatedAt: Int = getColumnIndexOrThrow(_stmt, "created_at")
        val _columnIndexOfIsHidden: Int = getColumnIndexOrThrow(_stmt, "isHidden")
        val _result: MutableList<VodCategoryWithVisibleStatus> = mutableListOf()
        while (_stmt.step()) {
          val _item: VodCategoryWithVisibleStatus
          val _tmpIsHidden: Boolean
          val _tmp: Int
          _tmp = _stmt.getLong(_columnIndexOfIsHidden).toInt()
          _tmpIsHidden = _tmp != 0
          val _tmpCategory: VodCategory
          val _tmpCategoryId: Int
          _tmpCategoryId = _stmt.getLong(_columnIndexOfCategoryId).toInt()
          val _tmpCategoryName: String?
          if (_stmt.isNull(_columnIndexOfCategoryName)) {
            _tmpCategoryName = null
          } else {
            _tmpCategoryName = _stmt.getText(_columnIndexOfCategoryName)
          }
          val _tmpParentId: Int?
          if (_stmt.isNull(_columnIndexOfParentId)) {
            _tmpParentId = null
          } else {
            _tmpParentId = _stmt.getLong(_columnIndexOfParentId).toInt()
          }
          val _tmpCreatedAt: Long
          _tmpCreatedAt = _stmt.getLong(_columnIndexOfCreatedAt)
          _tmpCategory = VodCategory(_tmpCategoryId,_tmpCategoryName,_tmpParentId,_tmpCreatedAt)
          _item = VodCategoryWithVisibleStatus(_tmpCategory,_tmpIsHidden)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun deleteAll() {
    val _sql: String = "DELETE FROM vodCategoriesTable"
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public companion object {
    public fun getRequiredColumnConverters(): List<KClass<*>> = emptyList()

    public fun getRequiredDaoReturnTypeConverters(): List<KClass<*>> = emptyList()
  }
}
